import React from 'react';
import CategoryNewsList from '../../components/categoryNews/CategoryNewsList';

export default function CategoryNewsManagement() {
    return (
        <div>
            <CategoryNewsList />
        </div>
    );
}
